export var SpaceOrFolder;
(function (SpaceOrFolder) {
    SpaceOrFolder["SPACE"] = "space";
    SpaceOrFolder["FOLDER"] = "folder";
})(SpaceOrFolder || (SpaceOrFolder = {}));
export var OtherPermission;
(function (OtherPermission) {
    OtherPermission["FOLDER_CREATE"] = "folder_create";
    OtherPermission["FOLDER_EDIT"] = "folder_edit";
    OtherPermission["FOLDER_COPY"] = "folder_copy";
    OtherPermission["FOLDER_MOVE"] = "folder_move";
    OtherPermission["FOLDER_DELETE"] = "folder_delete";
    OtherPermission["EXPORT"] = "export";
    OtherPermission["ASSIGN"] = "assign";
})(OtherPermission || (OtherPermission = {}));
